<template>
  <div class="type-review">
    <template v-if="$SO.size(dataTypes)">
      <div class="hair-type-wrapper">
        <div v-for="(hair, index) in dataTypes.slice(0, maxList)" :key="index" class="hair-type">{{ hair.name }}</div>
        <v-popover v-if="dataTypes.length > maxList" placement="bottom-end" offset="5" class="more-review">
          <!-- This will be the popover target (for the events and position) -->
          <div class="tooltip-target more-hair-type">
            <span v-for="i in 3" :key="i"></span>
          </div>
          <!-- This will be the content of the popover -->
          <template slot="popover">
            <p v-for="(hair, key) in dataTypes.slice(maxList, dataTypes.length)" :key="key">
              {{ hair.name.replace(/\,/g, '') }}
            </p>
          </template>
        </v-popover>
      </div>
    </template>
    <template v-else>
      <span class="gray-text">User has not completed the beauty profile</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'hair-types',
  props: {
    onlyHairTypes: {
      type: Boolean,
      default: true,
    },
    skinTypes: {
      type: Array,
      required: false,
      default: () => [],
    },
    hairTypes: {
      type: Array,
      required: true,
    },
  },
  computed: {
    dataTypes() {
      if (this.onlyHairTypes) {
        return this.hairTypes;
      } else {
        return [...this.hairTypes, ...this.skinTypes];
      }
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    maxList() {
      // return this.isDesktop ? 5 : 3; UI Team request to limit beauty profile to 3 to prevent broken diplay
      return 3;
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin gray-pill() {
  background: #f8f8f8;
  border-radius: 10.5px;
  padding: 2px 8px;
}
.hair-type-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 5px;
  .hair-type {
    @include gray-pill();
    font-family: 'Lato-Regular', sans-serif;
    font-size: 12px;
    color: #222222;
    text-align: left;
    line-height: 16px;
  }
  .more-hair-type {
    @include gray-pill();
    padding: 8px 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      background: #f384a7;
      height: 3px;
      width: 3px;
      border-radius: 50%;
      &:not(:last-child) {
        margin-right: 3px;
      }
    }
  }
}
.gray-text {
  font-family: 'Lato-Regular', sans-serif;
  font-size: 12px;
  color: #8c8582;
  text-align: left;
  line-height: 12px;
}
</style>
